// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3kGcM","noBorder":"styles_noBorder__1ncAF","label":"styles_label__2VQ2Z","value":"styles_value__3ljHj"};